/* @flow */
import cx from 'classnames';
import * as React from 'react';
import Glyph from 'components/Glyph.jsx';

import './styles/ReactionButton.scss';

type Props = {
  includeBorder?: ?boolean,
};

export default function ReactionButton({ includeBorder }: Props) {
  return (
    <div
      className={cx('ReactionButton', {
        'ReactionButton-border': includeBorder,
      })}>
      <Glyph name="reaction-smiley" size="xlarge" solo />
    </div>
  );
}
